import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FEATURE_NAMES } from '../../apis/featureLimits';
import LatestTrendingPost from '../LatestTrendingPost';
import { FloatingUsageIndicator } from './FeatureUsageIndicator';
import { validateProfileComplete } from '../../utils/profileValidation';

// Wrapper component that adds feature limiting to KnackFeeds without blocking the page
const KnackFeedsWithLimits = () => {
  const navigate = useNavigate();

  // Check profile completion on component mount
  useEffect(() => {
    if (!validateProfileComplete({ showAlert: true, navigate })) {
      // Profile is incomplete - alert already shown by validateProfileComplete
      // If user clicks "Go to Profile Hub", they will be redirected
    }
  }, [navigate]);

  return (
    <>
      <FloatingUsageIndicator 
        featureName={FEATURE_NAMES.KNACK_FEEDS} 
        position="top-right" 
      />
      <LatestTrendingPost />
    </>
  );
};

export default KnackFeedsWithLimits;
